import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import { Button } from '@nearpod-packages/base-library';
import { Modal, BackdropBackgroundModes, VerticalPositionModes } from '@nearpod-packages/core';
import bannerShort from '../../../../assets/ThumbnailBanner/banner_short.png.js';
import { useCustomTranslation } from '../../../../hooks/useCustomTranslation/useCustomTranslation.js';
import CouponCodesEnum from '../../../../enums/CouponCodesEnum.js';
import styles from './GoldActivityExclusive.scss.js';

const GoldActivityExclusive = _ref => {
  let {
    isOpen = false,
    onClose = () => {},
    onClick = () => {},
    activity,
    containerRef,
    isStandaloneModal = false
  } = _ref;
  const {
    tCustom
  } = useCustomTranslation();
  const getActivityNameAndDescription = () => {
    switch (activity) {
      case 'DragAndDrop':
        return {
          name: tCustom('TRY_DRAG_AND_DROP'),
          description: tCustom('DRAG_AND_DROP_DESCRIPTION'),
          coupon: CouponCodesEnum.NP_GOLD_DD
        };
      case 'MatchingPairs':
        return {
          name: tCustom('TRY_MATCHING_PAIRS'),
          description: tCustom('MATCHING_PAIRS_DESCRIPTION'),
          coupon: CouponCodesEnum.NP_GOLD_MP
        };
      case 'Collaborate':
        return {
          name: tCustom('TRY_COLLABORATE'),
          description: tCustom('COLLABORATE_DESCRIPTION'),
          coupon: CouponCodesEnum.NP_GOLD_CB
        };
      case 'FillInTheBlanks':
        return {
          name: tCustom('TRY_FILL_IN_THE_BLANKS'),
          description: tCustom('FILL_IN_THE_BLANKS_DESCRIPTION'),
          coupon: CouponCodesEnum.NP_GOLD_FB
        };
      case 'MemoryTest':
        return {
          name: tCustom('TRY_MEMORY_TEST'),
          description: tCustom('MEMORY_TEST_DESCRIPTION'),
          coupon: CouponCodesEnum.NP_GOLD_MT
        };
      case 'Quiz':
        return {
          name: tCustom('TRY_QUIZ'),
          description: tCustom('QUIZ_DESCRIPTION'),
          coupon: CouponCodesEnum.NP_GOLD_Q
        };
      default:
        return {
          name: '',
          description: ''
        };
    }
  };
  const activityData = getActivityNameAndDescription();
  return /*#__PURE__*/React.createElement(Modal, _extends({
    isOpen: isOpen,
    onClose: onClose,
    containerRef: containerRef
  }, isStandaloneModal ? {
    closeButton: true
  } : {
    backdropBackground: BackdropBackgroundModes.whiteGradient,
    verticalPositionOnContainer: VerticalPositionModes.top
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundImage: `url(${bannerShort})`
    },
    className: styles.wrapper__banner
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.wrapper__banner__text
  }, " ", tCustom('UPGRADE_TO_EDIT'), " ")), /*#__PURE__*/React.createElement("h2", {
    className: styles.wrapper__title
  }, activityData.name), /*#__PURE__*/React.createElement("p", {
    className: styles.wrapper__description
  }, activityData.description), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper__coupon
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.wrapper__coupon__description
  }, tCustom('TRY_GOLD_COUPON_2')), /*#__PURE__*/React.createElement("p", {
    className: styles.wrapper__coupon__code
  }, activityData.coupon)), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper__upgrade__cta
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClick
  }, tCustom('UPGRADE'))), /*#__PURE__*/React.createElement("p", {
    className: styles.wrapper__upgrade__note
  }, tCustom('TRY_GOLD_COUPON_NOTE'))));
};
var GoldActivityExclusive$1 = GoldActivityExclusive;

export { GoldActivityExclusive$1 as default };
//# sourceMappingURL=GoldActivityExclusive.js.map
